export enum PropertyTypeEnum {
    flatPrivate = 'flatPrivate',
    flatCooperative = 'flatCooperative',
    familyHouse = 'familyHouse',
    recreationalObject = 'recreationalObject',
    land = 'land',
    apartmentBuilding = 'apartmentBuilding',
    other = 'other',
}
